// @ts-nocheck
import { styled } from 'linaria/react';
import theme from '@clad-ui/theme';
import { css } from 'linaria';
const {
  colors,
  radii,
  sizes,
  space,
  mediaQueries,
  shadows,
  fontSizes,
  lineHeights,
  zIndices
} = theme;
const Modal = /*#__PURE__*/styled("div")({
  name: "Modal",
  class: "mfvmlz9"
});
const StyledPopup = /*#__PURE__*/styled("div")({
  name: "StyledPopup",
  class: "s1lvuq7b"
});
const StyledHeader = /*#__PURE__*/styled("div")({
  name: "StyledHeader",
  class: "s12klre3"
});
const StyledWrapper = /*#__PURE__*/styled("div")({
  name: "StyledWrapper",
  class: "s3x0hth"
});
const StyledButtonGroup = /*#__PURE__*/styled("div")({
  name: "StyledButtonGroup",
  class: "s1ue741y",
  vars: {
    "s1ue741y-0": [({
      btnGroupDirection
    }) => btnGroupDirection.flexDirection],
    "s1ue741y-2": [({
      position
    }) => position.justifyContent]
  }
});
const buttonClass = "bg0sa4l";
const CloseButton = /*#__PURE__*/styled("button")({
  name: "CloseButton",
  class: "c1pfi3m6"
});
const ChildrenWrapper = /*#__PURE__*/styled("div")({
  name: "ChildrenWrapper",
  class: "cx2zzgw"
});
const StyledImage = /*#__PURE__*/styled("img")({
  name: "StyledImage",
  class: "sq1zn3z"
});

// To visible children inside children wrapper in overflow-y case
const showChildrenOverflowClass = "s3f4cjj";
const Backdrop = /*#__PURE__*/styled("div")({
  name: "Backdrop",
  class: "b6p9h0e"
});
export { Modal, StyledPopup, CloseButton, StyledHeader, StyledWrapper, ChildrenWrapper, StyledButtonGroup, StyledImage, Backdrop, buttonClass, showChildrenOverflowClass };

require("../../../../../../../.linaria-cache/node_modules/.pnpm/clad-ui@0.20.20_mlt2zq6sucawkuesenn26jlwdu/node_modules/clad-ui/patterns/Popup/Popup.styles.linaria.module.css");